import { SocketIoApi } from '@unboared/lib';
import { Database } from '~/services/db';

export class UnboaredConsoleApi extends SocketIoApi {
    clientID: string;

    // Stable ID of the physical screen this console instance drives (undefined in
    // anim mode). Used to restrict Drive-to-Store offers to specific screens.
    screenID?: string;

    /**
     * Create a new webview api interface
     */
    constructor(
        clientID: string,
        initialScene: string,
        deviceType: 'gamepad' | 'screen',
        server: string,
        mode: string = 'auto',
        language: string = 'fr',
        supportsResume: boolean = true,
        screenID?: string
    ) {
        super(initialScene, deviceType, server, mode, language, undefined, supportsResume);
        this.clientID = clientID;
        this.screenID = screenID;
    }

    /**
     * This function saves highscore for a player
     * @param {string} gameID the game identifier
     * @param {string} deviceID the device identifier
     * @param {number} score the score to be saved
     * @param {string|undefined} _level the level identifier
     */
    saveHighscore(gameID: string, deviceID: string, score: number, _level?: string): void {
        const uid = this.getUID(deviceID);
        Database.highscore.saveScore(
            this.clientID,
            gameID,
            uid,
            score,
            {
                avatar: this.getAvatar(deviceID),
                username: this.getUsername(deviceID),
            },
            this.screenID
        );
    }
}
